import { clientApi } from "@/utils/api";

export type TDownloadBusinessReportParams = {
  matchOfficeId?: number;
  fiscalYear?: number;
};

/**
 * Download business report for a specific office
 * @param params - matchOfficeId (optional), fiscalYear (optional, defaults to current FY)
 */
export const downloadBusinessReportApi = async (params?: TDownloadBusinessReportParams) => {
  return await clientApi.get("/report/company-branch-report/download", {
    params,
    responseType: "blob",
  });
};
